module.exports = __webpack_public_path__ + "static/media/facebook.a52c2470.svg";